<template>
  <div>
    <h2 class="mb-2 text-20 font-medium">
      {{
        /* translators: Payment processing primary heading */
        $t('lemonsqueezy_checkout.payment_processing.primary_heading')
      }}
    </h2>
    <p class="text-balance">
      {{
        /* translators: Payment processing description */
        $t('lemonsqueezy_checkout.payment_processing.description')
      }}
    </p>
  </div>
</template>
